import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ShapeSorter.css';

const ShapeSorter = () => {
  const [shapes, setShapes] = useState([]);
  const [score, setScore] = useState(0);
  const [gameActive, setGameActive] = useState(false);
  const [draggedShape, setDraggedShape] = useState(null);
  const [timeLeft, setTimeLeft] = useState(60);

  const shapeTypes = ['🔴', '🔵', '🟢', '🟡'];
  const containers = ['🔴', '🔵', '🟢', '🟡'];

  const createShape = () => ({
    id: Date.now() + Math.random(),
    type: shapeTypes[Math.floor(Math.random() * shapeTypes.length)],
    x: Math.random() * 300,
    y: Math.random() * 200
  });

  const startGame = () => {
    setGameActive(true);
    setScore(0);
    setTimeLeft(60);
    setShapes([createShape(), createShape(), createShape()]);
  };

  useEffect(() => {
    if (!gameActive) return;

    const timer = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          setGameActive(false);
          return 0;
        }
        return t - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [gameActive]);

  const handleDragStart = (shape) => {
    setDraggedShape(shape);
  };

  const handleDrop = (containerType) => {
    if (!draggedShape) return;

    if (draggedShape.type === containerType) {
      setScore(s => s + 10);
      setShapes(shapes.filter(s => s.id !== draggedShape.id));
      if (shapes.length <= 3) {
        setShapes(s => [...s, createShape()]);
      }
    } else {
      setScore(s => Math.max(0, s - 5));
    }
    setDraggedShape(null);
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🎨 Shape Sorter</h1>
        <div className="game-instructions">
          Drag shapes to matching containers!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Score: {score} | Time: {timeLeft}s
        </div>
        
        <div className="game-play-area">
          <div className="sorter-game-area">
            <div className="shapes-area">
              {shapes.map(shape => (
                <div
                  key={shape.id}
                  className="draggable-shape"
                  draggable
                  onDragStart={() => handleDragStart(shape)}
                  style={{ left: shape.x, top: shape.y }}
                >
                  {shape.type}
                </div>
              ))}
            </div>

            <div className="containers-area">
              {containers.map(container => (
                <div
                  key={container}
                  className="drop-container"
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={() => handleDrop(container)}
                >
                  {container}
                </div>
              ))}
            </div>

            {!gameActive && (
              <div className="game-status-overlay">
                <div className="status-message">
                  {timeLeft === 0 ? `Final Score: ${score}` : 'Press Start!'}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="game-controls">
          <button className="btn btn-primary" onClick={startGame}>
            {timeLeft === 0 ? 'Play Again' : 'Start Game'}
          </button>
          <Link to="/" className="btn btn-secondary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default ShapeSorter;
